import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject,Input, ComponentFactoryResolver, Output, EventEmitter, OnDestroy,ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import {FormBuilder,FormControl, FormGroup,Validators,FormsModule} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap,RoutesRecognized } from '@angular/router';
import { AuthenticationService, LoggerService, statusCodes ,FlashService } from 'ew-common-lib';
import {EwMaIntegrationService } from '../ew-ma-integration.service';
import { DeleteConfirmationComponent } from '../delete-confirmation/delete-confirmation.component';

import { TranslateService } from '@ngx-translate/core';
import { EwMaIntegrationTranslateService } from '../services/ew-ma-integration-translate.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'lib-integrationform',
  templateUrl: './integrationform.component.html',
  styleUrls: ['./integrationform.component.css']
})
export class IntegrationformComponent implements OnInit {

  private contentPlaceholder:any;
  @ViewChild('mySelect', { static: false }) set content(content: ElementRef) {
   if(content) { // initially setter gets called with undefined
       this.contentPlaceholder = content;
   }
 }

   addInetgrationOption: boolean = false;
   @Input() allTags;
   @Input() allList ;
   @Input() campaigns ;
   //campaigns:any;
   @Input() allcustomFields;
   @Input() webinarCustomFields;
   offersTagging:any;
   @Input() actions;
   @Input() events;
   selectedEvent = '';
   selectedAction = '0' ;
   showLoader = 0;
   customFieldLoader = 0;
   selectedValue :any;
   selectedOffer :any;
   @Input() webinar_integration_details;
   @Input() webinar_integration_tags;
   @Input() offers;
   webinar_integration_custom_fields :any;
   minutesRange:any;
   hoursRange:any;
   selectedHours:number=0;
   selectedMinutes:number=0;
   selectedCustomfield:any;
   selectedWebinarCustomfield:any;
   selectedAdvaceField:any;
   buttonText = 'Save';
   customButtonText = 'Save Changes';
   @Input() customFieldType:number ;
   selectedList:string;
   showchangelistOption = false;
   affiliates:any;
   @Input() showGdpr;
   @Input() gdprSettingsSaved;
   @Input() gdprSettings;
   existingEvent:any;
   myForm: FormGroup;
   @Input() serviceName : string;
   @Input() default_lang = 'en';
   disableEvents:boolean = false;
   @Input() event_id:string;
   transLationMessages:any;   
   gotit_button_text = 'Got it'; 
   @Input() tagsType;
   @Input() showEditButton;
   @Input() offerstags;
   @Input() showdefaultForm;
   @Output() exit: any = new EventEmitter();
   @Output() parentFun: EventEmitter<any> = new EventEmitter<any>(); 
   @Output() showHideEditButtons: EventEmitter<any> = new EventEmitter<any>(); 
   public filterdLists:any;
   public filterdLists1:any;
   public filterdTags:any;
   public filterdTags1:any;
   public campaigns1:any;
   public filteredCampaigns:any;
   showHideDiv=1;
   selectedOfferkey = ''; 
   searchTags = '';
  searchList = '';
  searchListDropdownText = "Search";
  searchTagDropdownText = "Search";
  emptySearchText = "No entry matches";

   constructor(
     @Inject(DOCUMENT) private _document: any,
     private EwMaIntegrationService: EwMaIntegrationService,
     private authenticationService: AuthenticationService,
     public dialog: MatDialog,
     private router: Router,
     private activatedRoute: ActivatedRoute,
     private ewFlashService: FlashService,
     private fb: FormBuilder,
     private ewTranslateService: EwMaIntegrationTranslateService,
     public translate: TranslateService,
     private changeDetector : ChangeDetectorRef
     ) {
       translate.addLangs(["en", "es"]);
     }
 
     showDiv = {
       previous: false
     };
 
   ngOnInit(): void { 
    // this.initLanguage();
 
     this.serviceName = this.activatedRoute.snapshot.params.service_provider; 

     this.hoursRange = Array(8).fill(0).map((x,i)=>i);
     this.minutesRange = Array(60).fill(0).map((x,i)=>i);
     this.selectedCustomfield = {};
     this.selectedWebinarCustomfield = {};    
     this.transLationMessages = this.translate.store.translations[this.default_lang];
     this.gotit_button_text = this.transLationMessages.SNACKBAR_TEXT.GOT_IT_BUTTON;
     this.searchListDropdownText = this.transLationMessages.SEARCHLISTDROPDOWNTEXT;
     this.searchTagDropdownText = this.transLationMessages.SEARCHTAGDROPDOWNTEXT;
     this.emptySearchText = this.transLationMessages.Empty_SEARCH;
     this.myForm = this.fb.group({
       event:['', Validators.required],
       action: ['', Validators.required],
       value: ['', Validators.required],
       selectedHours:[''],
       selectedMinutes: [''],
       selectedOffer: [''],
       searchList:['search tag']
     });
 
 this.myForm.get('event').valueChanges
   .subscribe(value => {
     if(value == 'api_joined_webinar_after_tag' || value == 'api_stayed_event_atleast_tag'  || value == 'api_left_webinar_before_tag') {
       this.myForm.get('selectedHours').setValidators(Validators.required);
       this.myForm.get('selectedMinutes').setValidators(Validators.required);
     } else {
       this.myForm.get('selectedHours').setValidators([]);
       this.myForm.get('selectedMinutes').setValidators([]);      
     }
     this.myForm.get('selectedHours').updateValueAndValidity;
     this.myForm.get('selectedMinutes').updateValueAndValidity();
   });
   
 }


 keepOrder = (a, b) => {
  // return a;
  return (parseInt(a.key) > parseInt(b.key))?1:0;
 }
 
       integrationOption(){ 
         this.myForm.reset();
         this.addInetgrationOption = !this.addInetgrationOption;
         this.showHideEditButtons.emit(true);
       }
 
       saveIntegration(){ 
        if(this.myForm.valid){
          if((this.selectedEvent == 'api_delayed_clicked_tag' || this.selectedEvent == 'api_delayed_tag') && this.myForm.value.selectedOffer == null) {
            this.ewFlashService.openSnackBar("Please select offer first.",this.gotit_button_text,"error-ew-message");
            return;
          }
          let gdprSavedValue;
          if(this.gdprSettingsSaved == 1){
             gdprSavedValue = this.serviceName == 'drip' ? this.gdprSettings['account_id']+'@'+this.gdprSettings['value'] : this.gdprSettings['value'];
           }
  
          if(this.showGdpr == 1 &&  this.myForm.value.event != 'api_gdpr_tag' && (( this.webinar_integration_tags == undefined || Object.keys(this.webinar_integration_tags).length == 0) || this.gdprSettingsSaved == 0)){
            this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SELECT_GDPR_FIRST,this.gotit_button_text,"error-ew-message");
            return;
          }
  
          if(this.gdprSettingsSaved == 1 &&  this.myForm.value.event != 'api_gdpr_tag' && this.gdprSettings['action'] == this.myForm.value.action && gdprSavedValue == this.myForm.value.value){
            this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SELECT_DIFFRENT,this.gotit_button_text,"error-ew-message");
            return;
          }
          if(this.showGdpr == 1 && this.myForm.value.event == 'api_gdpr_tag' && ( this.webinar_integration_tags != undefined && Object.keys(this.webinar_integration_tags).length >0)){
  
            for (let prop in this.webinar_integration_tags) { 
              let alreadySavedActions = this.webinar_integration_tags[prop];
              if(alreadySavedActions['action'] == this.myForm.value.action &&  gdprSavedValue == this.myForm.value.value && this.serviceName != 'drip' ){
                this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.USE_DIFFERENT_LIST_FOR_GDPR,this.gotit_button_text,"error-ew-message");
                return;
              }
              if(alreadySavedActions['action'] == this.myForm.value.action && alreadySavedActions['account_id']+'@'+alreadySavedActions['value'] == this.myForm.value.value && this.serviceName == 'drip' ){
                this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.USE_DIFFERENT_LIST_FOR_GDPR,this.gotit_button_text,"error-ew-message");
                return;
              }
            }
  
          }
  
  
          this.buttonText = 'Saving';
          this.showLoader = 1;
          this.disableEvents = false;
         const  model = {
  
           'service_provider':this.serviceName,
           'action':this.myForm.value.action,
           'event':this.myForm.value.event,
           'existing_event':this.existingEvent,
           'value':this.myForm.value.value,
           'webinar_id':this.event_id,
           'hours':this.myForm.value.selectedHours,
           'minutes':this.myForm.value.selectedMinutes,
           'offer_id':this.myForm.value.selectedOffer
          };
          this.EwMaIntegrationService.saveIntegration(model).subscribe(
            (response: any) => {              
              this.showLoader = 0;
              this.showHideEditButtons.emit(false);
              if (response.status.code == statusCodes.SUCCESS) {  
                
                this.parentFun.emit();
                this.addInetgrationOption = false;
                this.myForm.reset();
                this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_SAVED_SUCC_MSG,this.gotit_button_text);
                this.buttonText = 'Save';
                this.selectedEvent = '';
                 return;
                
              }else{
                this.buttonText = 'Save';
                this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
              }
             
            },
            (error) => { 
              this.showHideEditButtons.emit(false);
              this.buttonText = 'Save';
              this.showLoader = 0;
              this.existingEvent = '';
              this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
            }
          );
        }else{ 
          this.showLoader = 0;
          this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.REQUIRED_FIELDS_MSG,this.gotit_button_text,"error-ew-message");
        }
  
        }
 
       /*
       Edit integration
       */
 
       public editIntegration(details){ console.log("+++",this.allTags);

        this.showHideEditButtons.emit(true);
        this.addInetgrationOption = false;
        for (let prop in this.webinar_integration_tags) { 
          if(this.showGdpr == 1 && prop == 'api_gdpr_tag'){
            this.gdprSettingsSaved = 1;
            this.gdprSettings = this.webinar_integration_tags[prop]; 
          }
           this.events[prop]['status'] = 0;
        }

        for (let prop in this.offerstags) {
          this.offerstags[prop] = 1;
        }

        
        this.showHideDiv = 0;
       // this.exit.showEditButton = 0;////
        // this.disableEvents = true;
         this.existingEvent = details.key;
         this.selectedEvent = details.key;
         this.selectedAction = details.value.action;
         if(this.serviceName == 'drip'){
           this.selectedValue = details.value.account_id+'@'+details.value.value;
         }else{
           this.selectedValue = details.value.value;
         }      
         this.events[this.selectedEvent]['status'] = 1;         
         this.myForm = this.fb.group({
           event:[this.selectedEvent, Validators.required],
           action: [this.selectedAction, Validators.required],
           value: [this.selectedValue, Validators.required],
           selectedHours:[''],
           selectedMinutes: [''],
           selectedOffer: ['']
         });
 
         if(details.key == 'api_joined_webinar_after_tag' || details.key == 'api_stayed_event_atleast_tag'  || details.key == 'api_left_webinar_before_tag') {
           this.selectedHours = details.value.hours; 
           this.selectedMinutes = details.value.minutes;
           this.myForm.get('selectedHours').setValue(this.selectedHours);
           this.myForm.get('selectedMinutes').setValue(this.selectedMinutes);
           this.myForm.get('selectedHours').setValidators(Validators.required);
           this.myForm.get('selectedMinutes').setValidators(Validators.required);
         } else { 
           this.myForm.get('selectedHours').setValidators([]);
           this.myForm.get('selectedMinutes').setValidators([]);      
         }       
       }
       public conditionChanged($event){ 
         if($event.value == 'api_joined_webinar_after_tag' || $event.value == 'api_stayed_event_atleast_tag'  || $event.value == 'api_left_webinar_before_tag') {
           this.myForm.get('selectedHours').setValidators(Validators.required);
           this.myForm.get('selectedMinutes').setValidators(Validators.required);
           this.myForm.get('selectedHours').updateValueAndValidity();   
           this.myForm.get('selectedMinutes').updateValueAndValidity();   
         } else if($event.value == 'api_joined_webinar_after_tag' || $event.value == 'api_stayed_event_atleast_tag'){
 
         }else { 
           this.myForm.get('selectedHours').setValidators([]);
           this.myForm.get('selectedMinutes').setValidators([]);   
           this.myForm.get('selectedHours').updateValueAndValidity();   
           this.myForm.get('selectedMinutes').updateValueAndValidity();   
         } 
       }
 
       public editOffersIntegration(details,key){ 
        for (let prop in this.webinar_integration_tags) { 
          if(this.showGdpr == 1 && prop == 'api_gdpr_tag'){
            this.gdprSettingsSaved = 1;
            this.gdprSettings = this.webinar_integration_tags[prop]; 
          }
           this.events[prop]['status'] = 0;
        }
        for (let prop in this.offerstags) {
          this.offerstags[prop] = 1;
        }
        this.showHideEditButtons.emit(true);
        this.addInetgrationOption = false;
         this.selectedOffer = details.id;
         this.offerstags[key+"_"+this.selectedOffer] = 0;
         this.selectedOfferkey = key+"_"+this.selectedOffer;
         this.showHideDiv = 0;
         for (let prop in details.tags) {
           if(prop == key){
             this.selectedEvent = prop;
             this.selectedAction = details.tags[prop]['action'];
             this.selectedValue = details.tags[prop]['value'];
           }
         }
         this.myForm = this.fb.group({
           event:[this.selectedEvent, Validators.required],
           action: [this.selectedAction, Validators.required],
           value: [this.selectedValue, Validators.required],
           selectedOffer: [this.selectedOffer] 
         });
        // this.addInetgrationOption = true;
       }
 
 

 


  closeIntegrationForm(){ 
   this.myForm.reset();
   this.selectedEvent='';
   this.existingEvent = '';
   this.showHideDiv = 1;
   this.addInetgrationOption=false;
   this.showHideEditButtons.emit(false);
   if(this.webinar_integration_details && this.webinar_integration_details.tags){ 
     this.showLoader = 0;
     this.webinar_integration_tags = this.webinar_integration_details.tags;
     for (let prop in this.webinar_integration_tags) {
        this.events[prop]['status'] = 0;
     }
   }else
   this.webinar_integration_tags = {};
   for (let prop in this.offerstags) {
    this.offerstags[prop] = 1;
  }
  }

  ngOnChanges(){
   let testAllTag = [];
    for (let prop in this.allTags) {
      testAllTag.push({'id':prop,"name":this.allTags[prop]});

    }
    this.filterdTags1 = testAllTag;
    this.filterdTags = [... this.filterdTags1];
    let testAllLists= [];
    for (let prop in this.allList) {
      testAllLists.push({'id':prop,"name":this.allList[prop]});

    }
    this.filterdLists1 = this.filterdLists = testAllLists;
    let testAllCamp= [];
    for (let prop in this.campaigns) {
      testAllCamp.push({'id':prop,"name":this.campaigns[prop]});

    }
    this.campaigns1 = this.filteredCampaigns = testAllCamp;
  }

  onKey(value) { 
   // let text = value.target.value;
    this.filterdTags = this.search(value);
  }

  change() {
    this.filterdTags = this.filterdTags1;
  }

  search(value: string) {
    let filter = value.toLowerCase();
    let alltags = this.filterdTags1; 
    let res =  alltags.filter(option => option.name.toLowerCase().includes(filter));
    return res;
  }

  reset(input:any) {
    input.value = '';
    this.onKey('');
  }

    /**
   * Filter dropdown options
   */
     public onChangeFilterTags(type) { console.log("this.searchList",this.searchList,this.searchTags);
     if(type == 'cam'){
      this.filterdLists=this.filterdLists1.filter(option => option.name.toLowerCase().includes(this.searchList));
      this.filteredCampaigns=this.campaigns1.filter(option => option.name.toLowerCase().includes(this.searchList));
     }
       if(type == 'list'){
        this.filterdLists=this.filterdLists1.filter(option => option.name.toLowerCase().includes(this.searchList));
       }else
       this.filterdTags=this.filterdTags1.filter(option => option.name.toLowerCase().includes(this.searchTags));
     
    }

  decodeHtmlData(text:string){
    let txt = document.createElement("textarea");
        txt.innerHTML = text.replace(/\\/g,'').replace(/&amp;/g, '&');
        return txt.value;
  
  }

}
